// Onboarding Services - API calls for onboarding flow
// This file imports and re-exports API functions from apiClient.js for better organization

import { 
  getCustomerDetails, 
  getStaffById, 
  updateStaffById, 
  getFacilities, 
  createFacility, 
  editFacility,
  getProviders,
  createProvider,
  updateProvider 
} from "../../utils/apiClient";
import apiClient from "../../utils/apiClient";
import { convertToUTC } from "../../utils/date-time-utils";

// Customer Services
export { getCustomerDetails } from "../../utils/apiClient";

/**
 * Updates customer information
 * @param {Object} customerData - The customer data to update
 * @returns {Promise<Object>} The update response
 */
export const updateCustomer = async (customerData) => {
  try {
    const response = await apiClient.put('/api/v1/customers', customerData);
    return response.data;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};

// Staff/Admin Services
export { getStaffById, updateStaffById } from "../../utils/apiClient";

// Facility Services
export { getFacilities, createFacility, editFacility } from "../../utils/apiClient";

// Provider Services
export { getProviders, createProvider, updateProvider } from "../../utils/apiClient";

/**
 * Marks onboarding as complete
 * @returns {Promise<Object>} The completion response
 */
export const completeOnboarding = async () => {
  try {
    const response = await apiClient.put('/api/v1/customers', {
      onboardingDate: convertToUTC(new Date().toISOString())
    });
    return response.data;
  } catch (error) {
    console.error("Error completing onboarding:", error);
    throw error;
  }
};

/**
 * Gets the current staff ID from session storage
 * @returns {string|null} The staff ID or null if not found
 */
export const getCurrentStaffId = () => {
  const staffInfo = sessionStorage.getItem('staff_info');
  if (staffInfo) {
    const staff = JSON.parse(staffInfo);
    return staff._id;
  }
  return null;
};

/**
 * Gets the current customer ID from session storage
 * @returns {string|null} The customer ID or null if not found
 */
export const getCurrentCustomerId = () => {
  const staffInfo = sessionStorage.getItem('staff_info');
  if (staffInfo) {
    const staff = JSON.parse(staffInfo);
    return staff.customerId;
  }
  return null;
}; 